import { render, staticRenderFns } from "./veStuHygieneItemNormEdit.vue?vue&type=template&id=78755fa8&scoped=true"
import script from "./veStuHygieneItemNormEdit.vue?vue&type=script&lang=js"
export * from "./veStuHygieneItemNormEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78755fa8",
  null
  
)

export default component.exports